import { useQuery, useQueryClient } from '@tanstack/react-query';
import { GET_REPORT } from '../../query/report/keys';
import { getReport } from '../../services/report/ReportService';
import { PdfReportResponse } from '../../../models/report/PdfReportResponse';
import { PeriodType } from '../../../types/prompt/PeriodType';
import { getPeriod } from '../../../helpers/StatsHelpers';

export const useGetReport = (
  projectId: number | null,
  from: Date | null,
  to: Date | null,
  period: string | undefined
) => {
  const queryClient = useQueryClient();
  const queryEnabled = !!projectId && !!from && !!to && !!period;

  const {
    data: report,
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery<PdfReportResponse>({
    queryKey: [GET_REPORT, projectId, from, to],
    queryFn: () => getReport(projectId!, getPeriod(period), from, to),
    staleTime: 1000 * 60 * 60 * 6,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    enabled: false,
  });

  return {
    report,
    isLoading: queryEnabled ? isLoading : false,
    isError: queryEnabled ? isError : false,
    error: queryEnabled ? error : null,
    refetch: async () => (!queryEnabled ? null : await refetch()),
    invalidate: () =>
      queryClient.invalidateQueries({
        queryKey: [GET_REPORT, projectId, from, to],
        refetchType: 'active',
      }),
  };
};
